import React from "react";
import "../styles/Upcoming.css";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";

function Upcoming() {

  return (
    <div className="container-box">

        <h1>Comming Soon...</h1>

    </div>
  );
}

export default Upcoming;
